import {isNull, isNumber} from 'lodash';

import {isChromeOrChromium117} from '../../../libs/shared/core/src/helpers/environment/platformHelpers';
import {
  getHasGrammarlyIntegration,
  getIsGrammarlyDisabledForChrome,
} from '../../../libs/shared/core/src/store/featureFlags/featureFlagsSelectors';
import {createSelector} from '../../../srcCommon/helpers/reselectHelpers';
import {getIsCompanyFront} from '../../store/data/company/companySelectors';
import {
  getGrammarlyIntegration,
  getIsGrammarlyIntegrationEnabled,
} from '../../store/data/integrations/integrationSelectors';
import {getIsGrammarlyEnabled} from '../../store/data/preferences/preferencesSelectors';

export const getIsGrammarlyAllEnabled = createSelector(
  [
    getHasGrammarlyIntegration,
    getIsGrammarlyEnabled,
    getIsGrammarlyIntegrationEnabled,
    getIsGrammarlyDisabledForChrome,
  ],
  (
    hasGrammarlyIntegration,
    isGrammarlyEnabled,
    isGrammarlyIntegrationEnabled,
    isGrammarlyDisabledForChrome,
  ) => {
    // Disable on problematic chrome version
    if (isGrammarlyDisabledForChrome && isChromeOrChromium117()) {
      return false;
    }

    return hasGrammarlyIntegration && isGrammarlyEnabled && isGrammarlyIntegrationEnabled;
  },
);

export const getCompanyHasGrammarlyPremium = createSelector(
  [getIsCompanyFront, getGrammarlyIntegration],
  (isCompanyFront, grammarlyIntegration) => {
    const accessToPremiumGrantedAt = grammarlyIntegration?.settings.accessToPremiumGrantedAt;
    const oneYearDate = isNumber(accessToPremiumGrantedAt) ? new Date(accessToPremiumGrantedAt) : null;
    if (!isNull(oneYearDate)) {
      oneYearDate.setFullYear(oneYearDate.getFullYear() + 1);
    }
    const isWithinOneYear = oneYearDate ? oneYearDate.getTime() > Date.now() : false;

    return isWithinOneYear || isCompanyFront;
  },
);
